import "./IconText.css";

const IconText = ({
  icon: Icon,
  iconElement,
  title,
  description,
  children,
  variant = "primary",
  size = "md",
  align = "start",
  iconSize = 18,
  boxed = false,
  hoverable = false,
  animation = "",
  className = "",
}) => {
  return (
    <div
      className={`ui-icon-text ${variant} ${size} ${align} ${
        boxed ? "boxed" : ""
      } ${hoverable ? "hoverable" : ""} ${animation} ${className}`}
    >
      {(Icon || iconElement) && (
        <span className="ui-icon-text-icon">
          {Icon ? <Icon size={iconSize} /> : iconElement}
        </span>
      )}

      <span className="ui-icon-text-content">
        {title && <span className="ui-icon-text-title">{title}</span>}
        {description && (
          <span className="ui-icon-text-description">{description}</span>
        )}
        {children}
      </span>
    </div>
  );
};

export default IconText;
